'use strict';

$(window).on('orientationchange', function () {
    if (window.orientation === 90 || window.orientation === -90) {
        $('.noxz').show();
    } else if (window.orientation === 0 || window.orientation === 180) {
        $('.noxz').hide();
        location.href = 'index.html';
    }
});
iniStage();
function iniStage() {
    var wW = $(window).width();
    var wH = $(window).height();
    var s = 1,
        gW = wW,
        gH = wH,
        str;
    if (wW < wH) {
        str = wW * 0.5 + 'px ' + wW * 0.5 + 'px';
        gW = wH;
        gH = wW;
        r = 90;
    } else {
        $('.noxz').show();
        str = '0px 0px';
        s = wH / 750;
        gW = Math.floor(wW / s);
        gH = 750;
        r = 0;
    }
    $('#main').css({ 'height': gH, 'width': gW, 'transform-origin': str, '-webkit-transform-origin': str, 'transform': 'rotate(' + r + 'deg) scale(' + s + ',' + s + ')', '-webkit-transform': 'rotate(' + r + 'deg) scale(' + s + ',' + s + ')' });
}
$(function () {
    $.ajax({
        url: 'http://h5.jingjiribao.cn/wuxih5/api/WxOpen/shareAuthByProject.json?project=hexin1',
        type: 'post',
        async: false,
        cache: false,
        data: {
            'url': window.location.href.split('#')[0]
        },
        success: function success(result) {
            var data = JSON.parse(result).data;
            var appId = data.appid;
            var timestamp = data.timestamp;
            var nonceStr = data.nonceStr;
            var signature = data.signature;
            shareConfig(appId, timestamp, nonceStr, signature);
        }
    });
    function shareConfig(appId, timestamp, nonceStr, signature) {
        wx.config({
            debug: !1,
            appId: appId,
            timestamp: timestamp,
            nonceStr: nonceStr,
            signature: signature,
            jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData']
        });
        wx.ready(function () {
            wx.updateAppMessageShareData({
                title: '改革开放号专列',
                desc: '共赴时光之旅，走你！',
                link: 'http://h5.jingjiribao.cn/wuxih5/resource/jjrb/index.html?from=weixin',
                imgUrl: 'http://h5oss.jingjiribao.cn/images/share.jpg',
                success: function success() {
                    // 设置成功
                }
            });
            wx.updateTimelineShareData({
                title: '改革开放号专列',
                link: 'http://h5.jingjiribao.cn/wuxih5/resource/jjrb/index.html?from=weixin',
                imgUrl: 'http://h5oss.jingjiribao.cn/images/share.jpg',
                success: function success() {
                    // 设置成功
                }
            });
        });
    }
    createjs.Sound.registerSounds([{ id: 'music3', src: 'music3.mp3' }], 'http://h5oss.jingjiribao.cn/music/');
    var manifest = ['http://h5oss.jingjiribao.cn/images/icon_music.png', 'http://h5oss.jingjiribao.cn/images/loading1.png', 'http://h5oss.jingjiribao.cn/images/loading2.png', 'http://h5oss.jingjiribao.cn/images/loading3.png', 'http://h5oss.jingjiribao.cn/images/loading4.png', 'http://h5oss.jingjiribao.cn/images/loading5.png', 'http://h5oss.jingjiribao.cn/images/p0.jpg', 'http://h5oss.jingjiribao.cn/images/p0-1.png', 'http://h5oss.jingjiribao.cn/images/p1.jpg', 'http://h5oss.jingjiribao.cn/images/p1-2.png', 'http://h5oss.jingjiribao.cn/images/p1-4.png', 'http://h5oss.jingjiribao.cn/images/p1-5.png', 'http://h5oss.jingjiribao.cn/images/p1-6.png', 'http://h5oss.jingjiribao.cn/images/p1-7.png', 'http://h5oss.jingjiribao.cn/images/p1-8.png', 'http://h5oss.jingjiribao.cn/images/p1-9.png', 'http://h5oss.jingjiribao.cn/images/p1-10.png', 'http://h5oss.jingjiribao.cn/images/p1-11.png', 'http://h5oss.jingjiribao.cn/images/p1-s1.png', 'http://h5oss.jingjiribao.cn/images/p1-s2.png', 'http://h5oss.jingjiribao.cn/images/p1-s3.png', 'http://h5oss.jingjiribao.cn/images/p1-s4.png', 'http://h5oss.jingjiribao.cn/images/p1-s5.png', 'http://h5oss.jingjiribao.cn/images/p2.png', 'http://h5oss.jingjiribao.cn/images/p2-1.jpg', 'http://h5oss.jingjiribao.cn/images/p2-2.png', 'http://h5oss.jingjiribao.cn/images/p2-3.png', 'http://h5oss.jingjiribao.cn/images/p2-s1.png', 'http://h5oss.jingjiribao.cn/images/p2-s2.png', 'http://h5oss.jingjiribao.cn/images/p2-s3.png', 'http://h5oss.jingjiribao.cn/images/p2-s4.png', 'http://h5oss.jingjiribao.cn/images/p2-s5.png', 'http://h5oss.jingjiribao.cn/images/p3.png', 'http://h5oss.jingjiribao.cn/images/p3-1.jpg', 'http://h5oss.jingjiribao.cn/images/p3-2.png', 'http://h5oss.jingjiribao.cn/images/p3-3.png', 'http://h5oss.jingjiribao.cn/images/p3-s1.png', 'http://h5oss.jingjiribao.cn/images/p3-s2.png', 'http://h5oss.jingjiribao.cn/images/p3-s3.png', 'http://h5oss.jingjiribao.cn/images/p3-s4.png', 'http://h5oss.jingjiribao.cn/images/p3-s5.png', 'http://h5oss.jingjiribao.cn/images/p3-s6.png', 'http://h5oss.jingjiribao.cn/images/p3-s7.png', 'http://h5oss.jingjiribao.cn/images/p4.png', 'http://h5oss.jingjiribao.cn/images/p4-1.jpg', 'http://h5oss.jingjiribao.cn/images/p4-2.jpg', 'http://h5oss.jingjiribao.cn/images/p4-3.jpg', 'http://h5oss.jingjiribao.cn/images/p4-4.png', 'http://h5oss.jingjiribao.cn/images/p4-5.png', 'http://h5oss.jingjiribao.cn/images/p4-s1.png', 'http://h5oss.jingjiribao.cn/images/p4-s2.png', 'http://h5oss.jingjiribao.cn/images/p4-s3.png', 'http://h5oss.jingjiribao.cn/images/p4-s4.png', 'http://h5oss.jingjiribao.cn/images/p4-s5.png', 'http://h5oss.jingjiribao.cn/images/p4-s6.png', 'http://h5oss.jingjiribao.cn/images/p5.png', 'http://h5oss.jingjiribao.cn/images/p5-1.jpg', 'http://h5oss.jingjiribao.cn/images/p5-2.png', 'http://h5oss.jingjiribao.cn/images/p5-s1.png', 'http://h5oss.jingjiribao.cn/images/p5-s2.png', 'http://h5oss.jingjiribao.cn/images/p5-s3.png', 'http://h5oss.jingjiribao.cn/images/p5-s5.png', 'http://h5oss.jingjiribao.cn/images/p5-s6.png', 'http://h5oss.jingjiribao.cn/images/p6-1.png', 'http://h5oss.jingjiribao.cn/images/p6-2.png', 'http://h5oss.jingjiribao.cn/images/p6-3.png', 'http://h5oss.jingjiribao.cn/images/p6-4.png', 'http://h5oss.jingjiribao.cn/images/p6-5.png', 'http://h5oss.jingjiribao.cn/images/p7-2.png', 'http://h5oss.jingjiribao.cn/images/p7-s1.jpg', 'http://h5oss.jingjiribao.cn/images/p7-s2.jpg', 'http://h5oss.jingjiribao.cn/images/p7-s3.jpg', 'http://h5oss.jingjiribao.cn/images/p7-s4.jpg', 'http://h5oss.jingjiribao.cn/images/p7-s5.jpg', 'http://h5oss.jingjiribao.cn/images/p7-s6.jpg', 'http://h5oss.jingjiribao.cn/images/p7-s7.jpg', 'http://h5oss.jingjiribao.cn/images/p7-s8.jpg', 'http://h5oss.jingjiribao.cn/images/p7-s9.jpg', 'http://h5oss.jingjiribao.cn/images/p7-s10.jpg'];
    var preload = new createjs.LoadQueue(true);
    preload.on('progress', handleFileProgress);
    preload.on('complete', loadComplete);
    preload.loadManifest(manifest);
    function handleFileProgress() {
        var progress = preload.progress * 100;
        $('#loading p').text((progress | 0) + '%');
        if (progress === 100) {
            $('#loading').hide();
        }
    }
    function loadComplete() {
        $('#loading').hide();
    }
    var music = document.getElementById('music');
    var music1 = document.getElementById('music1');
    var music2 = document.getElementById('music2');
    document.addEventListener('WeixinJSBridgeReady', function () {
        if (music.paused) {
            music.play();
        }
    }, false);
    var flag = true;
    $('.music_ico').click(function () {
        $(this).toggleClass('on');
        if (flag) {
            music.pause();
            flag = false;
        } else {
            flag = true;
            music.play();
        }
    });
    var w = $(window).height();
    $('.page0').one('touchstart', function () {
        music.play();
    });
    $('.page0 .p1').click(function () {
        $('.page0').fadeOut();
        $('.noxz1').show();
        setTimeout(function () {
            $('.noxz1').hide();
        }, 2000);
        cflag1 = 1;
    });
    $('.page2-0,.page3-0,.page4-0,.page5-0,.page6').width(w);
    var s1 = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
    var s2 = [1, 1, 1, 1, 1];
    var s3 = [1, 1, 1, 1, 1, 1, 1, 1];
    var s4 = [1, 1, 1, 1, 1, 1];
    var s5 = [1, 1, 1, 1, 1, 1];
    //站台
    var x1 = 0,
        z1 = 0,
        y1 = 0,
        yy1 = 0,
        t1 = 0,
        t2 = 0,
        t3 = 0,
        t4 = 0,
        cflag1 = 0,
        n = 0,
        m = 0;
    $('.page1')[0].addEventListener('touchstart', function (event) {
        z1 = Number.parseFloat(event.touches[0].clientY);
        x1 = Number.parseFloat($('.page1').css('left')) - z1;
        y1 = Number.parseFloat($('.page1 .p6').css('left'));
        yy1 = Number.parseFloat($('.page1 .p3').css('left'));
        t1 = Number.parseFloat($('.page1 .p5').css('left'));
        t2 = Number.parseFloat($('.page1 .p7').css('left'));
        t3 = Number.parseFloat($('.page1 .p8').css('left'));
        t4 = Number.parseFloat($('.page1 .p9').css('left'));
    });
    $('.page1')[0].addEventListener('touchmove', function (event) {
        if (!cflag1) {
            return;
        }
        var x = Number.parseFloat(event.touches[0].clientY);
        var xs = x1 + x;
        var xs1 = y1 + (x - z1) * 0.15;
        var xs2 = yy1 + (x - z1) * 0.15;
        var xs3 = t1 + (z1 - x) * 0.15;
        var xs4 = t2 + (z1 - x) * 0.15;
        var xs5 = t3 + (z1 - x) * 0.15;
        var xs6 = t4 + (z1 - x) * 0.15;
        if (xs > 0) {
            return;
        }
        if (xs < -10 && !!s1[5]) {
            s1[5] = 0;
            $('.page1 .p1').addClass('an1');
        } else if (xs < -200 && !!s1[0]) {
            s1[0] = 0;
            qp('.p1-s1');
            $('.page1 .p3').addClass('an2');
            $('.page1 .p6').addClass('an4');
        } else if (xs < -400 && !!s1[1]) {
            s1[1] = 0;
            qp('.p1-s2');
            $('.point').remove();
        } else if (xs < -600 && !!s1[6]) {
            s1[6] = 0;
            qp('.p1-s3');
            $('.page1 .p5').addClass('an3');
        } else if (xs < -800 && !!s1[2]) {
            s1[2] = 0;
            $('.page1 .p7').addClass('an5');
        } else if (xs < -1000 && !!s1[3]) {
            s1[3] = 0;
            qp('.p1-s4');
            $('.page1 .p8').addClass('an6');
        } else if (xs < -1200 && !!s1[4]) {
            s1[4] = 0;
            qp('.p1-s5');
        }
        if (xs < w - 2903) {
            n++;
        } else {
            $('.page1').css({
                left: xs
            });
            $('.page1 .p6').css({
                left: xs1
            });
            $('.page1 .p3').css({
                left: xs2
            });
            $('.page1 .p5').css({
                left: xs3
            });
            $('.page1 .p7').css({
                left: xs4
            });
            $('.page1 .p8').css({
                left: xs5
            });
            $('.page1 .p9').css({
                left: xs6
            });
        }
    });
    $('.page1')[0].addEventListener('touchend', function (event) {
        var _this = this;

        if (n > 3) {
            var le = Number.parseFloat(event.changedTouches[0].clientY);
            if (le - z1 < 10) {
                m++;
                if (m === 3) {
                    $('.page1').addClass('on');
                    setTimeout(function () {
                        $('.page1').addClass('cur');
                        setTimeout(function () {
                            $(_this).hide();
                            n = 0;
                            m = 0;
                            j1 = 0;
                            k1 = 0;
                            cflag1 = 0;
                            cflag2 = 1;
                        }, 800);
                    }, 500);
                }
            } else if (le - z1 > 0) {
                n = 0;
                m = 0;
            }
        }
    });
    //一
    var x2 = 0,
        y2 = 0,
        yy2 = 0,
        z2 = 0,
        c2 = 0,
        cflag2 = 0,
        n1 = 0,
        m1 = 0,
        j1 = 0,
        k1 = 0;
    $('.page2')[0].addEventListener('touchstart', function (event) {
        c2++;
        if (c2 === 2) {
            music1.play();
        }
        z2 = Number.parseFloat(event.touches[0].clientY);
        x2 = Number.parseFloat($('.page2').css('left')) - z2;
        y2 = Number.parseFloat($('.page2 .p1').css('left'));
        yy2 = Number.parseFloat($('.page2 .p2').css('left'));
    });
    $('.page2')[0].addEventListener('touchmove', function (event) {
        if (!cflag2) {
            return;
        }
        var x = Number.parseFloat(event.touches[0].clientY);
        var xs = x2 + x;
        var xs1 = xs * 2;
        var xs2 = y2 + (x - z2) * 0.1;
        var xs3 = yy2 + (x - z2) * 0.1;
        if (xs > 0) {
            j1++;
            return;
        }
        if (xs < -10 && !!s2[0]) {
            s2[0] = 0;
            qp('.p2-s1');
        } else if (xs < -330 && !!s2[1]) {
            s2[1] = 0;
            qp('.p2-s2');
            $('.page2').addClass('an');
            $('.yf1 img').addClass('on');
        } else if (xs < -700 && !!s2[2]) {
            s2[2] = 0;
            qp('.p2-s3');
        } else if (xs < -1000 && !!s2[3]) {
            s2[3] = 0;
            qp('.p2-s4');
        } else if (xs < -1200 && !!s2[4]) {
            s2[4] = 0;
            qp('.p2-s5');
        }
        if (xs < w - 2596) {
            n1++;
        } else {
            $('.page2').css({
                left: xs
            });
            $('.page2-0').css({
                left: xs1
            });
            $('.page2 .p1').css({
                left: xs2
            });
            $('.page2 .p2').css({
                left: xs3
            });
        }
    });
    $('.page2')[0].addEventListener('touchend', function (event) {
        if (n1 > 3) {
            var le = Number.parseFloat(event.changedTouches[0].clientY);
            if (le - z2 < 10) {
                m1++;
                if (m1 === 3) {
                    $('.page2').addClass('on');
                    music1.pause();
                    music1.currentTime = 0;
                    setTimeout(function () {
                        $('.page2').addClass('cur');
                        setTimeout(function () {
                            $('.page2').hide();
                            $('.page2-0').fadeOut(800, function () {
                                $(this).hide();
                            });
                            $('.page3').addClass('on1 on2');
                            setTimeout(function () {
                                $('.page3').removeClass('on2').css({
                                    'transform-origin': '2270px 230px',
                                    '-webkit-transform-origin': '2270px 230px'
                                });
                                n1 = 0;
                                m1 = 0;
                                j2 = 0;
                                k2 = 0;
                                cflag2 = 0;
                                cflag3 = 1;
                            }, 1000);
                        }, 800);
                    }, 500);
                }
            } else if (le - z2 > 0) {
                n1 = 0;
                m1 = 0;
            }
        }
        if (j1 > 3) {
            var le1 = Number.parseFloat(event.changedTouches[0].clientY);
            if (le1 - z2 > 10) {
                k1++;
                if (k1 === 3) {
                    music1.pause();
                    music1.currentTime = 0;
                    $('.page1').fadeIn(100, function () {
                        $('.page1').addClass('cur1');
                        setTimeout(function () {
                            $('.page1').removeClass('on cur cur1');
                            cflag1 = 1;
                            c2 = 0;
                        }, 800);
                    });
                }
            } else if (le1 - z2 < 0) {
                j1 = 0;
                k1 = 0;
            }
        }
    });
    //二
    var x3 = 0,
        c3 = 0,
        y3 = 0,
        yy3 = 0,
        z3 = 0,
        cflag3 = 0,
        n2 = 0,
        m2 = 0,
        j2 = 0,
        k2 = 0;
    $('.page3')[0].addEventListener('touchstart', function (event) {
        c3++;
        if (c3 === 2) {
            music2.play();
        }
        z3 = Number.parseFloat(event.touches[0].clientY);
        x3 = Number.parseFloat($('.page3').css('left')) - z3;
        y3 = Number.parseFloat($('.page3 .p1').css('left'));
        yy3 = Number.parseFloat($('.page3 .p2').css('left'));
    });
    $('.page3')[0].addEventListener('touchmove', function (event) {
        if (!cflag3) {
            return;
        }
        var x = Number.parseFloat(event.touches[0].clientY);
        var xs = x3 + x;
        var xs1 = xs * 1.7;
        var xs2 = y3 + (z3 - x) * 0.1;
        var xs3 = yy3 + (x - z3) * 0.1;
        if (xs > 0) {
            j2++;
            return;
        }
        if (xs < -20 && !!s3[0]) {
            s3[0] = 0;
            qp('.p3-s1');
        } else if (xs < -100 && !!s3[1]) {
            s3[1] = 0;
            qp('.p3-s2');
        } else if (xs < -400 && !!s3[7]) {
            s3[7] = 0;
            $('.yf2 img').addClass('on');
            qp('.p3-s8');
        } else if (xs < -700 && !!s3[2]) {
            s3[2] = 0;
            qp('.p3-s3');
        } else if (xs < -900 && !!s3[3]) {
            s3[3] = 0;
            qp('.p3-s4');
        } else if (xs < -1200 && !!s3[4]) {
            s3[4] = 0;
            qp('.p3-s5');
        } else if (xs < -1250 && !!s3[5]) {
            s3[5] = 0;
            qp('.p3-s6');
        } else if (xs < -1300 && !!s3[6]) {
            s3[6] = 0;
            qp('.p3-s7');
        }
        if (xs < w - 2816) {
            n2++;
        } else {
            $('.page3').css({
                left: xs
            });
            $('.page3-0').css({
                left: xs1
            });
            $('.page3 .p1').css({
                left: xs2
            });
            $('.page3 .p2').css({
                left: xs3
            });
        }
    });
    $('.page3')[0].addEventListener('touchend', function (event) {
        if (n2 > 3) {
            var le = Number.parseFloat(event.changedTouches[0].clientY);
            if (le - z3 < 10) {
                m2++;
                if (m2 === 3) {
                    $('.page3').addClass('on');
                    music2.pause();
                    music2.currentTime = 0;
                    setTimeout(function () {
                        $('.page3').addClass('cur');
                        setTimeout(function () {
                            $('.page3').hide();
                            $('.page3-0').fadeOut(800, function () {
                                $(this).hide();
                            });
                            $('.page4').addClass('on1 on2');
                            setTimeout(function () {
                                $('.page4').removeClass('on2').css({
                                    'transform-origin': '2180px 100px',
                                    '-webkit-transform-origin': '2180px 100px'
                                });
                                n2 = 0;
                                m2 = 0;
                                j3 = 0;
                                k3 = 0;
                                cflag3 = 0;
                                cflag4 = 1;
                            }, 1000);
                        }, 800);
                    }, 500);
                }
            } else if (le - z3 > 0) {
                n2 = 0;
                m2 = 0;
            }
        }
        if (j2 > 3) {
            var le1 = Number.parseFloat(event.changedTouches[0].clientY);
            if (le1 - z3 > 10) {
                k2++;
                $('.page3').css({
                    '-webkit-transform-origin': '620px 220px',
                    'transform-origin': '620px 220px'
                });
                if (k2 === 3) {
                    music2.pause();
                    music2.currentTime = 0;
                    $('.page2-0').fadeIn();
                    $('.page3').addClass('on2 on3');
                    setTimeout(function () {
                        $('.page2').fadeIn(100, function () {
                            $('.page2').addClass('cur1');
                            setTimeout(function () {
                                $('.page2').removeClass('on cur cur1');
                                $('.page3').removeClass('on1 on2 on3');
                                cflag2 = 1;
                                c3 = 0;
                            }, 800);
                        });
                    }, 800);
                }
            } else if (le1 - z3 < 0) {
                j2 = 0;
                k2 = 0;
                $('.page3').removeClass('on2').css({
                    'transform-origin': '2270px 230px',
                    '-webkit-transform-origin': '2270px 230px'
                });
            }
        }
    });
    //三
    var x4 = 0,
        y4 = 0,
        z4 = 0,
        cflag4 = 0,
        n3 = 0,
        m3 = 0,
        j3 = 0,
        k3 = 0;
    $('.page4')[0].addEventListener('touchstart', function (event) {
        z4 = Number.parseFloat(event.touches[0].clientY);
        x4 = Number.parseFloat($('.page4').css('left')) - z4;
        y4 = Number.parseFloat($('.page4 .p1').css('left'));
    });
    $('.page4')[0].addEventListener('touchmove', function (event) {
        if (!cflag4) {
            return;
        }
        var x = Number.parseFloat(event.touches[0].clientY);
        var xs = x4 + x;
        var xs1 = xs * 2;
        var xs2 = y4 + (x - z4) * 0.1;
        if (xs > 0) {
            j3++;
            return;
        }
        if (xs < -10 && !!s4[0]) {
            s4[0] = 0;
            qp('.p4-s1');
        } else if (xs < -300 && !!s4[1]) {
            s4[1] = 0;
            qp('.p4-s2');
        } else if (xs < -400 && !!s4[2]) {
            s4[2] = 0;
            qp('.p4-s3');
        } else if (xs < -900 && !!s4[3]) {
            s4[3] = 0;
            qp('.p4-s5');
        } else if (xs < -1200 && !!s4[4]) {
            s4[4] = 0;
            qp('.p4-s4');
        } else if (xs < -1300 && !!s4[5]) {
            s4[5] = 0;
            qp('.p4-s6');
        }
        if (xs < w - 2596) {
            n3++;
        } else {
            $('.page4').css({
                left: xs
            });
            $('.page4-0').css({
                left: xs1
            });
            $('.page4 .p1').css({
                left: xs2
            });
        }
    });
    var timeid1 = null,
        timeid2 = null,
        mum;
    $('.page4')[0].addEventListener('touchend', function (event) {
        var _this2 = this;

        if (n3 > 3) {
            var le = Number.parseFloat(event.changedTouches[0].clientY);
            if (le - z4 < 10) {
                m3++;
                if (m3 === 3) {
                    $('.page4').addClass('on');
                    mum = createjs.Sound.play('music3');
                    setTimeout(function () {
                        $('.page4').addClass('cur');
                        $('.page4-1').show();
                        setTimeout(function () {
                            $('.page4').hide();
                            timeid1 = setTimeout(function () {
                                $('.page4-1 .p1').fadeIn();
                                timeid2 = setTimeout(function () {
                                    $('.page4-1').addClass('on');
                                    setTimeout(function () {
                                        $('.page4-1').hide();
                                        $('.page4-0').fadeOut(800, function () {
                                            $(this).hide();
                                        });
                                        $('.page5').addClass('on1 on2');
                                        setTimeout(function () {
                                            $('.page4-1').removeClass('on');
                                            $('.page4-1 .p1').hide();
                                            $('.page5').removeClass('on2').css({
                                                'transform-origin': '2240px 445px',
                                                '-webkit-transform-origin': '2240px 445px'
                                            });
                                            n3 = 0;
                                            m3 = 0;
                                            j4 = 0;
                                            k4 = 0;
                                            cflag4 = 0;
                                            cflag5 = 1;
                                        }, 1000);
                                    }, 500);
                                }, 1700);
                            }, 4950);
                        }, 800);
                        $(_this2).on('webkitTransitionEnd', function () {});
                    }, 500);
                }
            } else if (le - z4 > 0) {
                n3 = 0;
                m3 = 0;
            }
        }
        if (j3 > 3) {
            var le1 = Number.parseFloat(event.changedTouches[0].clientY);
            if (le1 - z4 > 10) {
                k3++;
                $('.page4').css({
                    '-webkit-transform-origin': '620px 220px',
                    'transform-origin': '620px 220px'
                });
                if (k3 === 3) {
                    $('.page3-0').fadeIn();
                    $('.page4').addClass('on2 on3');
                    setTimeout(function () {
                        $('.page3').fadeIn(100, function () {
                            $('.page3').addClass('cur1');
                            setTimeout(function () {
                                $('.page3').removeClass('on cur cur1');
                                $('.page4').removeClass('on1 on2 on3');
                                cflag3 = 1;
                            }, 800);
                        });
                    }, 800);
                }
            } else if (le1 - z4 < 0) {
                j3 = 0;
                k3 = 0;
                $('.page4').removeClass('on2').css({
                    'transform-origin': '2180px 100px',
                    '-webkit-transform-origin': '2180px 100px'
                });
            }
        }
    });
    var u1 = 0;
    $('.page4-1')[0].addEventListener('touchstart', function (event) {
        u1 = Number.parseFloat(event.touches[0].clientY);
    });
    $('.page4-1')[0].addEventListener('touchend', function (event) {
        var le = Number.parseFloat(event.changedTouches[0].clientY);
        if (u1 - le > 10) {
            clearTimeout(timeid1);
            // mum.paused = true;
            mum.position = 6050;
            $('.page4-1 .p1').fadeIn();
            timeid2 = setTimeout(function () {
                $('.page4-1').addClass('on');
                setTimeout(function () {
                    $('.page4-1').hide();
                    $('.page4-0').fadeOut(800, function () {
                        $(this).hide();
                    });
                    $('.page5').addClass('on1 on2');
                    setTimeout(function () {
                        $('.page4-1').removeClass('on');
                        $('.page4-1 .p1').hide();
                        $('.page5').removeClass('on2').css({
                            'transform-origin': '2240px 445px',
                            '-webkit-transform-origin': '2240px 445px'
                        });
                        n3 = 0;
                        m3 = 0;
                        j4 = 0;
                        k4 = 0;
                        cflag4 = 0;
                        cflag5 = 1;
                    }, 1000);
                }, 500);
            }, 1700);
        }
    });
    //四
    var x5 = 0,
        y5 = 0,
        z5 = 0,
        cflag5 = 0,
        n4 = 0,
        m4 = 0,
        j4 = 0,
        k4 = 0;
    $('.page5')[0].addEventListener('touchstart', function (event) {
        z5 = Number.parseFloat(event.touches[0].clientY);
        x5 = Number.parseFloat($('.page5').css('left')) - z5;
        y5 = Number.parseFloat($('.page5 .p1').css('left'));
    });
    $('.page5')[0].addEventListener('touchmove', function (event) {
        if (!cflag5) {
            return;
        }
        var x = Number.parseFloat(event.touches[0].clientY);
        var xs = x5 + x;
        var xs1 = xs * 1.8;
        var xs2 = y5 + (x - z5) * 0.1;
        if (xs > 0) {
            j4++;
            return;
        }
        if (xs < -10 && !!s5[0]) {
            s5[0] = 0;
            qp('.p5-s1');
        } else if (xs < -100 && !!s5[1]) {
            s5[1] = 0;
            qp('.p5-s2');
        } else if (xs < -300 && !!s5[2]) {
            s5[2] = 0;
            qp('.p5-s3');
        } else if (xs < -1200 && !!s5[4]) {
            s5[4] = 0;
            qp('.p5-s5');
        } else if (xs < -1500 && !!s5[5]) {
            s5[5] = 0;
            qp('.p5-s6');
        }
        if (xs < w - 3026) {
            n4++;
        } else {
            $('.page5').css({
                left: xs
            });
            $('.page5-0').css({
                left: xs1
            });
            $('.page5 .p1').css({
                left: xs2
            });
        }
    });
    $('.page5')[0].addEventListener('touchend', function (event) {
        if (n4 > 3) {
            var le = Number.parseFloat(event.changedTouches[0].clientY);
            if (le - z5 < 10) {
                m4++;
                if (m4 === 3) {
                    $('.page6').show(100, function () {
                        $(this).addClass('on');
                    });
                }
            } else if (le - z5 > 0) {
                n4 = 0;
                m4 = 0;
            }
        }
        if (j4 > 3) {
            var le1 = Number.parseFloat(event.changedTouches[0].clientY);
            if (le1 - z5 > 10) {
                k4++;
                $('.page5').css({
                    '-webkit-transform-origin': '220px 250px',
                    'transform-origin': '220px 250px'
                });
                if (k4 === 3) {
                    $('.page4-0').fadeIn();
                    $('.page5').addClass('on2 on3');
                    setTimeout(function () {
                        $('.page4').fadeIn(100, function () {
                            $('.page4').addClass('cur1');
                            setTimeout(function () {
                                $('.page4').removeClass('on cur cur1');
                                $('.page5').removeClass('on1 on2 on3');
                                cflag4 = 1;
                            }, 800);
                        });
                    }, 800);
                }
            } else if (le1 - z5 < 0) {
                j4 = 0;
                k4 = 0;
                $('.page5').removeClass('on2').css({
                    'transform-origin': '2240px 445px',
                    '-webkit-transform-origin': '2240px 445px'
                });
            }
        }
    });

    var sc = Number.parseFloat((w / 1540).toFixed(3));
    $('.page6 .p4').css({
        'width': 96 * sc + 'px',
        'top': 587 * sc + 'px',
        'left': 543 * sc + 'px'
    });
    $('.page6').css({
        'transform-origin': Number.parseInt(580 * sc) + 'px ' + Number.parseInt(610 * sc) + 'px',
        '-webkit-transform-origin': Number.parseInt(580 * sc) + 'px ' + Number.parseInt(610 * sc) + 'px'
    });
    $('.page6').on('webkitTransitionEnd', function () {
        $('.page6 .p1,.page6 .p2,.page6 .p3').fadeIn();
    });
    function qp(dom) {
        $(dom).fadeIn();
    }
    $('.page6 .p2').click(function () {
        location.reload();
    });
    function random(min, max) {
        return Math.floor(min + Math.random() * (max - min + 1));
    }
    var ran = random(0, 9);
    $('.page7 .p1').attr('src', 'http://h5oss.jingjiribao.cn/images/p7-s' + ran + '.jpg');
    $('.page6 .p3').click(function () {
        $('.page7').fadeIn();
    });
    $('.page7 .close').click(function () {
        $('.page7').fadeOut();
    });
});